import { SvgIcon, SvgIconProps } from "@mui/material";

export const SingleUserIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M20 20v-.75A4.25 4.25 0 0 0 15.75 15h-7.5A4.25 4.25 0 0 0 4 19.25V20"
      />
      <circle
        cx="12"
        cy="7"
        r="4"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </svg>{" "}
  </SvgIcon>
);
